// TODO: These fields will need to be downloaded from the server when they are added.
import { generateItemCIDKey } from '../components/Items/utils/generateItemCIDKey';

export const mergeItemWithUserData = (
  { data: backendItem },
  { data: userData },
) => ({
  ...backendItem,
  streamItemId: backendItem.id,
  metadata: {
    ...backendItem.metadata,
    rebuzzCount:
      backendItem.metadata.rebuzzCount || backendItem.metadata.shareCount,
    archived: false,
    pinInterval: null,
    archiveInterval: null,
    freezeThreadOn: false,
    tipCoins: 0,
    tipCurrency: 0,
  },
  lockedCoins: null,
  bountyPurse: [],
  userData,
});

export const mergeItemsListWithUserData = (
  { data: itemsList },
  { data: userDataMap },
) => ({
  ...itemsList,
  items: itemsList.items.map(item =>
    mergeItemWithUserData(
      { data: item },
      { data: userDataMap[generateItemCIDKey(item)] },
    ),
  ),
});
